import { InputSize } from "./types";

export type FormMode = "light" | "dark";

export type FormColor = "primary" | "secondary";

export type FormVariant = "filled" | "text";

export const STYLE_MAP: Record<
  FormMode,
  Record<FormVariant, Record<FormColor, string>>
> = {
  light: {
    filled: {
      primary: "text-gray-900 bg-white border-gray-300",
      secondary: "text-gray-600 bg-white border-gray-300"
    },
    text: { primary: "text-gray-900", secondary: "text-gray-600" }
  },
  dark: {
    filled: {
      primary: "text-gray-200 bg-gray-700 border-gray-800",
      secondary: "text-gray-400 bg-gray-700 border-gray-800"
    },
    text: { primary: "text-gray-200", secondary: "text-gray-400" }
  }
};

export const SIZE_MAP: Record<InputSize, string> = {
  small: "py-1.5 px-3 text-sm",
  regular: "py-2 px-3 text-sm"
};

export const BASE_INPUT_COLORS =
  "border border-gray-200 disabled:bg-gray-200 focus:ring-cyan-600/30 active:border-cyan-600 focus:border-cyan-600 focus-visible:outline-none";

export const READ_ONLY_CLASSES =
  "read-only:focus:ring-gray-400/30 read-only:active:border-gray-400 read-only:focus:border-gray-400";
